export default __webpack_public_path__ + "static/media/healthapp-screenshot.1484b87c.png";